import { SVGProps } from 'react';

export const CloseOutline = ({
  width = 16,
  height = 16,
  stroke = '#494949',
  strokeWidth = '1.5',
  className,
}: SVGProps<SVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.5 4.5L4.5 11.5M11.5 11.5L4.5 4.5L11.5 11.5Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
